import { render, staticRenderFns } from "./CreateRule.vue?vue&type=template&id=470b3256&scoped=true&"
import script from "./CreateRule.vue?vue&type=script&lang=js&"
export * from "./CreateRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470b3256",
  null
  
)

export default component.exports